var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.295 3.788h4.084a2.23 2.23 0 0 1 2.227 2.227v1.231l-10.338 3.181a.186.186 0 0 1-.11 0L.817 7.246v-1.23a2.23 2.23 0 0 1 2.228-2.228h4.083v-.743A2.23 2.23 0 0 1 9.356.818h3.712a2.23 2.23 0 0 1 2.227 2.227v.743zm-6.681-.743v.743h5.197v-.743a.743.743 0 0 0-.743-.742H9.356a.743.743 0 0 0-.742.742zM21.606 8.8l-9.902 3.047c-.32.099-.663.099-.983 0L.818 8.8v3.898H2.33.82v3.712a2.23 2.23 0 0 0 2.227 2.227h16.332a2.23 2.23 0 0 0 2.228-2.227V12.697h-1.511H21.606V8.799z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projectsIcon.91cd6e4221bca4af7f622921bdc7da85.svg";
export { ForwardRef as ReactComponent };